import axios from '@/api/axios'

// 服务器代理地址
const BASE_URL = process.env.VUE_APP_BASE_URL

// ===================================《 SummaryData 》

// H5看板——汇总统计
export function xtCount(parameter) {
  return axios({
    url: BASE_URL + '/h5/xt_count',
    method: 'get',
    params: parameter
  })
}

// H5看板——明细数据
export function xtList(parameter) {
  return axios({
    url: BASE_URL + '/h5/xt_list',
    method: 'get',
    params: parameter
  })
}
